import { useCallback } from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { readAuthToken } from '@noor/api';
import { env } from '@noor/config';
import {
  foodOrderSearchSchema,
  foodOrderQueries,
  type FoodOrderSearch,
} from '@/entities/food-order';
import { FoodOrdersPage } from '@/pages/food-orders';
export const Route = createFileRoute('/food/orders')({
  staticData: { permission: 'food_orders.view' },
  beforeLoad: () => {
    if (!env.VITE_ENABLE_MSW && !readAuthToken()) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/login' });
    }
  },
  validateSearch: foodOrderSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => {
    // prefetchQuery ignores `enabled`; restaurant and client still require an ID.
    if (deps.scope === 'by-merchant' || deps.entityId) {
      void context.queryClient.prefetchQuery(foodOrderQueries.list(deps));
    }
  },
  component: FoodOrdersRoute,
});
function FoodOrdersRoute() {
  const params = Route.useSearch();
  const navigate = Route.useNavigate();
  const onChange = useCallback(
    (next: Partial<FoodOrderSearch>) => {
      const filterChange = Object.keys(next).some(
        (key) => !['page', 'orderId'].includes(key),
      );
      void navigate({
        search: (previous) => ({
          ...previous,
          ...next,
          ...(filterChange ? { page: 1 } : {}),
        }),
      });
    },
    [navigate],
  );
  return <FoodOrdersPage params={params} onChange={onChange} />;
}
